export const SET_SCRIPTS = 'SET_SCRIPTS';
export const SET_JOBS = 'SET_JOBS';
export const SET_SELECTED_JOBS = 'SET_SELECTED_JOBS';
export const SET_TASKS = 'SET_TASKS';